import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPackages, deletePackage } from "../../../actions/admin/package";
import AdminPage from "../_components/AdminPage";
import AdminTable from "../_components/AdminTable";
import AdminDeleteModal from "../_components/AdminDeleteModal";
import PackageItem from "./PackageItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Package Name", width: "tw:w-[260px]" },
  { key: "airport", title: "Airport", width: "tw:w-[220px]" },
  { key: "locations", title: "Locations", width: "tw:w-[280px]" },
  { key: "vehicleType", title: "Vehicle Type", width: "tw:w-[180px]" },
  { key: "rate", title: "Rate", width: "tw:w-[140px]" },
  { key: "status", title: "Status", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "action", title: "Action", width: "tw:w-[140px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const PackageList = () => {
  const trippackage = useSelector((state) => state.trippackage);
  const { loading, tpackages } = trippackage;
  const [delId, setDelId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPackages());
  }, [dispatch]);

  const delPkgfromPopup = () => {
    dispatch(deletePackage(delId));
    setDelId(null);
  };

  return (
    <AdminPage title="Package List">
      <AdminDeleteModal
        show={!!delId}
        title="Delete this package?"
        message="This cannot be undone."
        onCancel={() => setDelId(null)}
        onConfirm={delPkgfromPopup}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1440}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!tpackages?.length}
        emptyText="No packages found."
      >
        {tpackages?.map((item, index) => (
          <PackageItem key={item._id} package={item} count={index} deletePackage={setDelId} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default PackageList;
